import { writable } from 'svelte/store';

export const textInput = writable(null);
export const colorInput = writable(null);
